import "./_Styles/ReadOnly.css";

/*
    Indice lateral reutilizable para vistas profundas de solo lectura.
    Solo recibe secciones que realmente existen; cada boton navega al
    bloque correspondiente sin transformar el lector en un formulario.
*/
export const ReadOnlySectionNav = ({
    items = [],
    heading = "En este registro",
    activeId = null,
    onSelect = null,
}) => {
    const VISIBLE_ITEMS = (items ?? []).filter((item) => item && item.isVisible !== false);

    if (!VISIBLE_ITEMS.length) return null;

    return (
        <nav className="LStudio__readonly_section_nav" aria-label={heading}>
            <strong className="LStudio__readonly_section_nav_heading">{heading}</strong>

            <div className="LStudio__readonly_section_nav_list">
                {VISIBLE_ITEMS.map((item) => (
                    <button
                        key={item.id}
                        type="button"
                        className="LStudio__readonly_section_nav_item"
                        data-active={activeId === item.id ? "true" : "false"}
                        onClick={() => onSelect?.(item.id)}
                    >
                        {item.icon && <span className="LStudio__readonly_section_nav_icon">{item.icon}</span>}
                        <span className="LStudio__readonly_section_nav_label">{item.label}</span>
                        {item.count !== undefined && item.count !== null && (
                            <em>{item.count}</em>
                        )}
                    </button>
                ))}
            </div>
        </nav>
    );
};
